import React, { useState, useEffect } from 'react';
import AppointmentListMobile from './appointmentListMobile';
import AppointmentListWeb from './appointmentListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const AppointmentListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  if (width === 0) {
    return null;
  }

  return width < MOBILE_BREAKPOINT ? (
    <AppointmentListMobile {...props} />
  ) : (
    <AppointmentListWeb {...props} />
  );
};

export default AppointmentListRouter;
